import React from "react";
import "./Sidebar.css";

import { useHistory } from "react-router-dom";

interface NavItemProps {
  collapsed: boolean;
  icon: React.ReactNode;
  label: string;
  href?: string;
  onClick?: () => void;
}

const NavItem = ({ collapsed, icon, label, href, onClick }: NavItemProps) => {
  const history = useHistory();
  const isActive = href ? window.location.pathname === href : false;

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (href) {
      history.push(href);
    }
  };

  return (
    <div
      className={`menu-item ${isActive ? "active" : ""}`}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && handleClick()}
    >
      <div className="menu-icon">{icon}</div>
      {!collapsed && <span className="menu-text">{label}</span>}
    </div>
  );
};

export default NavItem;
